import { API } from "aws-amplify";
import { constructStatusQueryString } from "utils/actions";

export const GET_AUDIT_LIST_REQUEST = "@@audit/GET_AUDIT_LIST_REQUEST";
export const GET_AUDIT_LIST_SUCCESS = "@@audit/GET_AUDIT_LIST_SUCCESS";
export const GET_AUDIT_LIST_FAILURE = "@@audit/GET_AUDIT_LIST_FAILURE";

export function getAuditList(id, entity_type, formData) {
  return async (dispatch) => {
    dispatch({
      type: GET_AUDIT_LIST_REQUEST,
    });
    try {
      let url = `/audit/${entity_type}/${id}`;
      if (formData) {
        url = constructStatusQueryString(url, formData);
      }
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_AUDIT_LIST_SUCCESS,
        payload: {
          ...response,
          entity_type,
        },
      });
    } catch (error) {
      dispatch({
        type: GET_AUDIT_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_AUDITS = "@@audit/CLEAR_AUDITS";

export function clearAuditHistory() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_AUDITS,
    });
  };
}
